<template>
<div class="c-o-page-header" :class="{'c-o-page-header--with-background-image' : image}" :style="{ 'background-image': backgroundStyle}">
    <div class="c-o-page-header__inner">

        <div class="c-o-page-header__block">
            <h1 class="c-o-page-header__title" v-if="title">{{title}}</h1>
            <div  class="c-o-page-header__body o-wysiwyg" v-if="body" v-html="body"></div>
        </div>

    </div>
</div>
</template>

<script>

import Icon from '../atoms/AtomIcon.vue';

export default {
    components: {
        Icon
    },
    props: {
        title: {
            type: String
        },
        body: {
            type: String
        },
        image: {
            type: String
        }
    },
    computed: {

        backgroundStyle: function() {
            if (this.image) {
                return `url(${this.image})`;
            }
            return '';
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismPageHeader.vue